
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { SelectedFilter } from '../../../../components/Filters/types';
import { fetchApi } from '../../../../lib/fetchApi';
import { ExtractFnReturnType, QueryConfig } from '../../../../lib/react-query';
import { RootState } from '../../../../redux/store';
import { Pagination, PaginationFilterDto } from '../../../../types/Pagination';
import { EventEndDeleteRequestDto, EventRequestDto, EventsListFields } from "../types";

const BASE_URL = "/event";

export const getEvents = async (body: PaginationFilterDto): Promise<Pagination<EventsListFields>> => {    
    const response = await fetchApi.post(`${BASE_URL}/`, body) as Pagination<EventsListFields>;
    return response;
};

export const useEvents = ({ config, search = "", filters = [] }: UseSearchRolesOptions = {}) => {
    const historical = useSelector((state: RootState) => state.historical.events);

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["events", historical.currentPage, historical.itemsPerPage, search, JSON.stringify(filters)],
        queryFn: () =>
            getEvents({
                pageNumber: historical.currentPage,
                pageSize: historical.itemsPerPage,
                search,
                filters
            }),
    });
};


export const saveEvent = async (
    body: EventRequestDto
): Promise<EventRequestDto> => {
    const response = await fetchApi.post('/event/save', body) as EventRequestDto;
    return response;
}

export const deleteLogicEvent = async (eventId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${eventId}`);
};

export const endEvent = async (id: number, endDate: Date): Promise<void> => {

    const body: EventEndDeleteRequestDto = {
        Id: id,
        EndDate: endDate
    };

    await fetchApi.put(`${BASE_URL}/end`, body);

};


export const getEventById = async (idEvent: string): Promise<EventRequestDto> => {
    const response = await fetchApi.get(`/event/${idEvent}`) as EventRequestDto;
    return response
};

type QueryFnType = typeof getEvents;

type UseSearchRolesOptions = {
    config?: QueryConfig<QueryFnType>;
    search?: string;
    filters?: SelectedFilter[];
};